<template>
    <v-flex d-flex justify-space-between align-center>
        <div class="arrow-btn d-inline-flex rotate-180" v-if="backPage" @click="back">
            <ArrowRightIcon/>
        </div>
        <div class="title-text d-inline-flex">
            {{ title }}
        </div>
        <div class="d-inline-flex align-center">
            <div class="d-inline-flex" @click="openNotificationList">
                <NotificationUnreadIcon v-if="hasNotification"/>
                <NotificationIcon v-else/>
            </div>
        </div>
    </v-flex>
</template>

<script>
import ArrowRightIcon from "@/assets/icons/ArrowRightIcon";
import NotificationIcon from "@/assets/icons/NotificationIcon";
import NotificationUnreadIcon from "@/assets/icons/NotificationUnreadIcon";

export default {
    name: "HeaderMenu",
    components: {
        ArrowRightIcon,
        NotificationIcon,
        NotificationUnreadIcon,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        backPage: {
            type: Boolean,
            default: false,
        },
        hasNotification: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            active: 0,
            valueMenu: true,
        }
    },
    methods: {
        openNotificationList() {
            this.$router.push({ name: "notificationlist" });
        },
        back() {
            this.$router.go(-1);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>